const initUSPSwiper = () => {
  if (window.screen.width <= 768) {
    uspSwiper = new Swiper('.usp-wrapper.swiper-container', {
      autoplay: {
       delay: 3000,
     },
      slidesPerView: 1,
    });
  }
}


window.addEventListener('resize', function(event) {
    initUSPSwiper();
}, true);

